<template>
  <div class="dashboard-card">
    <v-card class="actual-card">
      <v-card-title>Quick Links</v-card-title>
      <v-card-text>
        <v-list>
          <draggable
            :list="list"
            :disabled="!enabled"
            handle=".handle"
            ghost-class="ghost"
            :move="checkMove"
            @start="dragging = true"
            @end="draggingFinished"
          >
            <div v-for="link in list" :key="link.id">
              <v-list-item dense>
                <v-list-item-icon>
                  <v-icon class="handle">mdi-drag</v-icon>
                </v-list-item-icon>
                <img class="logo" :src="link.logo" />
                <v-list-item-content class="link-content" @click="openLink(link)">
                  <v-list-item-title v-text="link.displayText" />
                </v-list-item-content>
                <v-icon @click="prepRemove(link)">mdi-close</v-icon>
              </v-list-item>
              <v-divider />
            </div>
            <div v-if="!list || list.length === 0" class="add-first-link-text">(Add your first quick link)</div>
          </draggable>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="showAddDialog = true">Add a link</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="showRemoveDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline"> Remove this link? </v-card-title>
        <v-card-text>
          <p>Are you sure you want to remove this link?</p>
          <p>{{ removeLink.displayText }} ( {{ removeLink.linkValue }})</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" darken-1" text @click="showRemoveDialog = false"> Cancel </v-btn>
          <v-btn color="red darken-1" text @click="remove(removeLink.id)"> Remove Link </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAddDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Add Link</v-card-title>
        <v-card-text>
          <v-form v-model="addLinkIsValid">
            <v-text-field label="Link Text" :rules="[isRequired]" v-model="linkToAdd.displayText" />
            <v-text-field label="Web Address" :rules="[webAddress]" v-model="linkToAdd.linkValue" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color=" darken-1" text @click="showAddDialog = false"> Cancel </v-btn>
          <v-btn color="secondary" :disabled="!addLinkIsValid" text @click="add(linkToAdd)"> Add Link </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import formRules from '@/mixins/form-rules'

export default {
  components: { draggable },
  mixins: [formRules],
  async mounted() {
    await this.getLinks()
  },
  data: () => {
    return {
      enabled: true,
      list: [
        // {
        //   id: 500,
        //   displayOrder: 1,
        //   displayText: 'Reddit!',
        //   linkValue: 'https://www.reddit.com/',
        //   isHidden: false,
        //   type: 'EXTERNAL',
        // },
      ],
      dragging: false,
      showRemoveDialog: false,
      removeLink: {},
      // Add
      showAddDialog: false,
      linkToAdd: {
        displayText: undefined,
        linkValue: undefined,
      },
      addLinkIsValid: undefined,
    }
  },
  methods: {
    async getLinks() {
      const url = `/api/accounts/${this.accountCode}/hotlinks`
      try {
        const response = await this.$http.get(url)
        this.list = response.data.map(this.mapFavicon.bind(this))
      } catch (ex) {
        console.error(ex)
        this.$error('Failed to get links')
      }
    },
    mapFavicon(link) {
      link.logo = this.getLogoForUrl(link.linkValue)
      return link
    },
    getLogoForUrl(url, size = 32) {
      return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${url}&size=${size}`
    },
    async add(linkToAdd) {
      console.log('add ' + linkToAdd)
      const url = `/api/accounts/${this.accountCode}/hotlinks`
      try {
        await this.$http.post(url, linkToAdd)
        await this.getLinks()
        this.showAddDialog = false
        this.linkToAdd.displayText = undefined
        this.linkToAdd.linkValue = undefined
      } catch (ex) {
        console.error(ex)
        this.$error('Failed to add link')
      }
    },
    checkMove: function () {
      // window.console.log('Future index: ' + e.draggedContext.futureIndex)
    },
    prepRemove(link) {
      this.removeLink = link
      this.showRemoveDialog = true
    },
    async remove(id) {
      console.log('remove ' + id)
      const url = `/api/accounts/${this.accountCode}/hotlinks/${id}`
      try {
        await this.$http.delete(url)
        await this.getLinks()
        this.showRemoveDialog = false
      } catch (ex) {
        console.error(ex)
        this.$error('Failed to delete link')
      }
    },
    async draggingFinished() {
      this.dragging = false

      const url = `/api/accounts/${this.accountCode}/hotlinks/order`
      try {
        await this.$http.put(url, this.list)
        await this.getLinks()
      } catch (ex) {
        console.error(ex)
        this.$error('Failed to save reorder')
      }
    },
    openLink(link) {
      if (link.linkValue.startsWith('www.')) {
        window.open('https://' + link.linkValue)
      } else {
        window.open(link.linkValue)
      }

      // internal:
      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);
    },
  },
  computed: {
    accountCode() {
      return this.$route.params.accountId
    },
  },
}
</script>
<style scoped lang="scss">
@import '~@/scss/variables';
.dashboard-card {
  height: 100%;
}

.ghost {
  opacity: 0.3;
  background: $primary;
}

.handle {
  cursor: pointer;
}

.logo {
  width: 20px;
  height: 20px;
  margin-left: -20px;
  margin-right: 8px;
}

.link-content {
  text-decoration: underline;
  color: $primary;
  &:hover {
    //background-color: rgba($darker, 0.5);
    cursor: pointer;
  }
}
.add-first-link-text {
  color: rgb(0, 0, 0, 0.5);
}

.actual-card {
  &.v-card {
    height: 100%;
    min-height: 318px;
  }
  .v-card__text {
    padding-bottom: 3rem;

    max-height: 13rem;
    overflow-y: auto;
  }
  .v-card__actions {
    padding-top: 1rem;
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>
